"use strict";

// Class definition
var KTSlidersWidget2_Devnet = function() {
    // Private methods
    var initChart = function(query, colorPalette) {
        var element = document.querySelector(query);

        if ( !element) {
            return;
        }              
        
        if ( element.classList.contains("initialized") ) {
            return;
        }

        var height = parseInt(KTUtil.css(element, 'height'));
        var baseColor = colorPalette ? KTUtil.getCssVariableValue(`--bs-${colorPalette}`) : KTUtil.getCssVariableValue('--bs-primary');
        var lightColor = colorPalette ? KTUtil.getCssVariableValue(`--bs-light-${colorPalette}`): KTUtil.getCssVariableValue('--bs-light-primary');         

        var options = {
            series: [parseInt(element.getAttribute("data-female-pop-percent")) ? element.getAttribute("data-female-pop-percent"): 50],
            chart: {
                fontFamily: 'inherit',
                height: height,
                type: 'radialBar',
                sparkline: {
                    enabled: true,
                }
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: "55%"
                    },
                    dataLabels: {
                        showOn: "always",
                        name: {
                            show: false,
                            offsetY: -10                                 
                        },
                        value: {                                 
                            show: true,
                            fontSize: "18px",
                            offsetY: 6
                        }
                    },
                    track: {
                        background: lightColor,
                        strokeWidth: '100%'
                    }
                }
            },
            colors: [baseColor],
            stroke: {
                lineCap: "round",
            },
        };

        var chart = new ApexCharts(element, options);
        chart.render();
        element.classList.add('initialized');
    }

    // Public methods
    return {
        init: function () {
            // Init default chart
            initChart('#kt_slider_widget_2_chart_1', 'primary');

            var carousel = document.querySelector('#kt_sliders_widget_2_slider');
            
            if(!carousel){
                return;
            }
            carousel.addEventListener('slid.bs.carousel', function (e) {
                if (e.to === 1) {
                    // Init second chart
                    initChart('#kt_slider_widget_2_chart_2', 'warning');
                }

                if (e.to === 2) {
                    // Init third chart
                    initChart('#kt_slider_widget_2_chart_3', 'success');
                }
            });
        }   
    }        
}();


// Webpack support
if (typeof module !== 'undefined') {
    module.exports = KTSlidersWidget2_Devnet;
}

// On document ready
KTUtil.onDOMContentLoaded(function() {
    KTSlidersWidget2_Devnet.init();
});
   
        
        
        
           